import React, {useContext, useEffect, useState} from "react";
import Column from "@meridian/components/column";
import Loading from "../commons/Loading";
import {AppNavigationContext} from "../appNavigation/context/AppNavigationContext";
import {SALPrinterContext} from "../scanPrinter/context/SALPrinterContext";
import {SALPrinterActions} from "../scanPrinter/actions/SALPrinterActions";
import {ResponseStatus} from "../utils/ResponseStatus";
import {TaskView} from "dolphin-meridian-react-components";
import {Flow, Routes} from "../utils/Routes";
import {injectIntl} from "react-intl";
import {updateAlert} from "../utils/utils";

const HomeView = (props) => {
    const {statePrinter, dispatchPrinter} = useContext(SALPrinterContext);
    const {navActions: {setupHelp, errorNavCol, resetNavCol, closeOnBack}} = useContext(AppNavigationContext);

    const [alert, setAlert] = useState(null);

    const onInductWithPrint = () => {
        dispatchPrinter({type: SALPrinterActions.GET_SAL_FORMAT, data: {dispatcher: dispatchPrinter}});
    }

    const onInductWithoutPrint = () => {
        dispatchPrinter({type: SALPrinterActions.INDUCT_WITHOUT_PRINTER});
        props.history.push(Routes.INDUCT_LOCATION_WITHOUT_PROPS + Flow.SCAN);
    }

    const tasks = [{
        title: props.intl.formatMessage({id: "home.receive_packages"}),
        description: props.intl.formatMessage({id: "home.receive_package_by_scanning_them"}),
        onClick: onInductWithoutPrint
    }, {
        title: props.intl.formatMessage({id: "home.print_label_and_receive"}),
        description: props.intl.formatMessage({id: "home.print_attach_sal"}),
        onClick: onInductWithPrint
    }];

    useEffect(() => {
        resetNavCol();
        closeOnBack();
        setupHelp(true, {list: []});
        return () => dispatchPrinter({type: SALPrinterActions.RESET_RESPONSE});
    }, []);

    useEffect(() => {
        if (statePrinter.salFormatResponseStatus === ResponseStatus.SUCCESS) {
            props.history.push(Routes.INDUCT_LOCATION_WITHOUT_PROPS + Flow.PRINT);
            dispatchPrinter({type: SALPrinterActions.RESET_RESPONSE});
        }
        else if (statePrinter.salFormatResponseStatus === ResponseStatus.ERROR) {
            updateAlert(setAlert, resetNavCol, errorNavCol,
                "warning", props.intl.formatMessage({id: "connection_failed"}));
        }
        else if (statePrinter.salFormatResponseStatus === ResponseStatus.NO_INTERNET) {
            updateAlert(setAlert, resetNavCol, errorNavCol,
                "error", "No Internet");
        }
        else updateAlert(setAlert, resetNavCol);
    }, [statePrinter.salFormatResponseStatus])

    return (
        statePrinter.salFormatResponseStatus === ResponseStatus.LOADING ? <Loading /> :
            <Column spacing="none">
                {alert}
                <TaskView pageTitle={props.intl.formatMessage({id: "home.select_induct_task"})} tasks={tasks} />
            </Column>
    );
}

export default injectIntl(HomeView);


// WEBPACK FOOTER //
// ./src/components/home/HomeView.js